/*
 * @Author: your name
 * @Date: 2022-03-18 10:00:32
 * @LastEditTime: 2023-01-06 11:10:34
 * @LastEditors: 陈传勋 593837024@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /xlian-web-pharmacy/src/utils/query.js
 */
import CryptoJS from 'crypto-js'

const encryption = '1iM2r0ebICBeXAdg'

const encodeReserveRE = /[!'()*]/g
const encodeReserveReplacer = (c) => '%' + c.charCodeAt(0).toString(16)
const commaRE = /%2C/g
const encode = (str) =>
  encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ',')
const decode = decodeURIComponent

// 加密方法
export function encrypt(word) {
  const key = CryptoJS.enc.Utf8.parse(encryption)
  const srcs = CryptoJS.enc.Utf8.parse(word)
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

// 解密方法
export function decrypt(ciphertext) {
  const key = CryptoJS.enc.Utf8.parse(encryption)
  const decrypt = CryptoJS.AES.decrypt(ciphertext, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}

// 加密参数
export const stringifyQuery = (obj) => {
  const res = obj
    ? Object.keys(obj)
      .map((key) => {
        const val = obj[key]

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          const result = []
          val.forEach((val2) => {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key))
            } else {
              result.push(encode(key) + '=' + encode(val2))
            }
          })
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter((x) => x.length > 0)
      .join('&')
    : null
  return res ? `?${encrypt(res)}` : ''
}

// 解密参数
export const parseQuery = (query) => {
  const res = {}
  query = query.trim().replace(/^(\?|#|&)/, '')

  if (!query) {
    return res
  }

  query = decrypt(query)
  query.split('&').forEach((param) => {
    const parts = param.replace(/\+/g, ' ').split('=')
    const key = decode(parts.shift())
    const val = parts.length > 0 ? decode(parts.join('=')) : null

    if (res[key] === undefined) {
      res[key] = val
    } else if (Array.isArray(res[key])) {
      res[key].push(val)
    } else {
      res[key] = [res[key], val]
    }
  })
  return res
}

export const openTabByCryptoQuery = function(path, query) {
  const newUrl = location.origin + '/web' + path + stringifyQuery(query)
  window.open(newUrl, '_blank')
}
